import React from 'react';
import { ThemeProvider } from '@mui/material';
import { CaptureConsole, Dedupe } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { BrowserTracing, Integrations } from '@sentry/tracing';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
//
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { customTheme } from './component/theme/customTheme';
import './index.css';
import { persistor, store } from './store/store';

/* eslint-disable */
// WRONG TAG
// const tagManagerArgs = {
//   gtmId: 'AW-609041373',
// };
// TagManager.initialize(tagManagerArgs);

const sentryConfig = {
  dsn: 'https://2e2be51a379a4a8492db4435b013c3da@o4505130627956736.ingest.sentry.io/4505130638770176',
  integrations: [
    new BrowserTracing(),
    new CaptureConsole({
      levels: ['error'],
    }),
    new Dedupe(),
  ] as any[],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: process.env.REACT_APP_ENVIRONMENT ?? 'localhost',
  release: process.env.REACT_APP_SENTRY_RELEASE,
  beforeSend: (event: any) => {
    if (window.location.hostname === 'localhost') {
      return null;
    }
    return event;
  },
};
console.log('Sentry config:', sentryConfig);
Sentry.init(sentryConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <PersistGate loading={null} persistor={persistor}>
      <Provider store={store}>
        <ThemeProvider theme={customTheme}>
          <App />
        </ThemeProvider>
      </Provider>
    </PersistGate>
  </React.StrictMode>,
);
/* eslint-enable */
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
